import Icon from 'veui/components/Icon'

Icon.register({
  cloud: {
    paths: [
      {
        d: 'M576 640H192c-88.22 0-160-71.78-160-160a160.08 160.08 0 01112.15-152.72 240 240 0 01479.7 0A160.08 160.08 0 01736 480c0 88.22-71.78 160-160 160zM384 160c-97 0-176 79-176 176 0 4.7.2 9.53.58 14.35a32 32 0 01-28.1 34.34A96 96 0 00192 576h384a96 96 0 0011.52-191.31 32 32 0 01-28.1-34.34c.38-4.82.58-9.65.58-14.35 0-97-78.95-176-176-176z'
      }
    ],
    width: '768',
    height: '768'
  }
})
